<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="编辑外协厂家">
      </el-page-header>
      <form class="form-horizontal" @submit.prevent="handleOrderUpdate">
        <div class="panel-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group col-sm-12">
                <label class="col-md-2 control-label">外协厂家</label>
                <div class="col-md-5">
                  <select
                    class="selectpicker col-sm-12"
                    data-live-search="true"
                    data-width="100%"
                    v-model="order.factory_id"
                  >
                    <option value="0">请选择</option>
                    <option
                      :value="item.id"
                      v-for="item in factories"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group col-sm-12">
                <label class="col-md-2 control-label">交货时间</label>
                <div class="col-md-5">
                  <date-picker
                    class="datepicker"
                    input-class="form-control"
                    placeholder="交货时间"
                    :not-before="new Date()"
                    :clearable="false"
                    v-model="order.deliver_time"
                    value-type="format"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-lg-5 col-md-6">
              <div class="col-md-7 col-md-offset-4">
                <button class="btn btn-success btn-labeled">提交</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { orderShow, orderFactory, factoryList } from '@/service/getData'

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      order: {
        id: this.$route.params.id,
        factory: null,
        deliver_time: null,
        // sale_type: null,
        // shackle_plate: 1,
        // package_type: null,
        factory_id: 0,
      },
      factories: [],
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      $('.selectpicker')
        .chosen()
        .change(function () {
          that.order.factory_id = parseInt($(this).val())
        })
    })
  },
  methods: {
    async initData() {
      let id = this.$route.params.id
      if (id) {
        let res = await orderShow(id)
        if (res.data.status != 3) {
          alert('该订单已填写厂家信息')
          this.$router.go(-1)
        }
      }

      let res = await factoryList()
      this.factories = res.data.list
      this.$nextTick(() => {
        $('.selectpicker').chosen().trigger('chosen:updated')
      })
    },
    async handleOrderUpdate() {
      let res = await orderFactory(this.order)
      if (res.code == 0) {
        this.$message({
          message: '操作成功！',
          type: 'success',
        })
        this.$router.go(-1)
      }
    },
  },
}
</script>